// NOTE: 'syncEvents' is for storing offline submitted pending events to sync with back end when
// get online but 'events' is for storing an offline list of events to show when offline
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

import userPermissions from './userPermissions';

const addEvent = (event) => new Promise(async (resolve, reject) => {
    try {
        const checkPermission = event.farmId ? await userPermissions
            .checkHasPermission(event.farmId, 'write_log') : null;
        if (!event.farmId || (event.farmId && checkPermission?.success && checkPermission?.permission)) {

            const userId = localStorage.getItem('userId');

            if (userId) {
                const offlineId = Date.now();
                const eventToSave = {
                    userId,
                    offlineId,
                    ...event,
                }

                const db = await connector();
                const transaction = db.transaction('syncEvents', 'readwrite');
                const syncEventsStore = transaction.objectStore('syncEvents');

                syncEventsStore.add(eventToSave);
                transaction.oncomplete = () => {
                    db.close();
                    resolve({ success: true, offlineId });
                };
            }
            else {
                resolve({ success: false, error: 'Error: User not found!' });
            }
        }
        else {
            resolve({ success: false, code: 403, error: 'Error: Permission denied!' });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEvents', 'readonly');
        const syncEventsStore = transaction.objectStore('syncEvents');

        const allEvents = syncEventsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allEvents.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventByOfflineId = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEvents', 'readonly');
        const syncEventsStore = transaction.objectStore('syncEvents');

        const event = syncEventsStore.get(offlineId);

        transaction.oncomplete = () => {
            db.close();
            if (event && event.result) {
                resolve({ success: true, event: event.result });
            }
            else {
                resolve({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const deleteEvent = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEvents', 'readwrite');
        const syncEventsStore = transaction.objectStore('syncEvents');

        syncEventsStore.delete(offlineId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const syncEvents = {
    addEvent,
    getEventsList,
    getEventByOfflineId,
    deleteEvent
}

export default syncEvents;
